import { render, staticRenderFns } from "./milestone-onboarding-dialog.vue?vue&type=template&id=04ce2fb2&scoped=true&"
import script from "./milestone-onboarding-dialog.vue?vue&type=script&lang=ts&"
export * from "./milestone-onboarding-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-onboarding-dialog.vue?vue&type=style&index=0&id=04ce2fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce2fb2",
  null
  
)

export default component.exports